module.exports = __webpack_public_path__ + "media/file_icons/powerpoint-fdc78fc5.png";